<template>
    <div class="vue-block">
        <a
            class="single-product__info-box-cta"
            href="javascript:;"
            @click="show = !show"
            >
            <div class="single-product__info-box-cta-container">
            <SvgIcon class="single-product__info-box-cta-btn-icon" iconName="ico-plus-regular" />
            <span>Add to List</span></div></a
        >
        <template v-if="show">
            <div
                v-on-click-outside="closePopup"
                class="product-info-box__add-list-predefined-wrap"
            >
                <div
                    class="product-info-box__add-list-close-btn js-product-info-box__add-list-close-btn"
                    @click="show = false"
                ></div>
                <span class="product-info-box__add-list-title"
                    >Add to List</span
                >
                <div>
                    <perfect-scrollbar class="ps-popup">
                        <div class="product-info-box__add-list-predefined">
                            <label
                                class="product-info-box__add-list-predefined-checkbox"
                            >
                                <input
                                    :checked="favorites[productId.toString()]"
                                    type="checkbox"
                                    name="compare"
                                    @click="addToFavorites($event)"
                                />
                                <span>Favorites</span>
                            </label>
                            <a
                                class="product-info-box__add-list-predefined-cta-btn"
                                :href="
                                    kadraGlobal.Url +
                                        '/single-my-lists?id=favorites'
                                "
                                >View List</a
                            >
                        </div>
                        <div
                            class="product-info-box__add-list-predefined"
                            v-for="wish in wishlist"
                            :key="wish.ID"
                        >
                            <label
                                class="product-info-box__add-list-predefined-checkbox"
                            >
                                <input
                                    :checked="check(wish.ID)"
                                    type="checkbox"
                                    name="compare"
                                    @click="addToWishlist(wish.ID, $event)"
                                />
                                <span
                                    v-html="wishTitleShort(wish.title)"
                                ></span>
                            </label>
                            <a
                                class="product-info-box__add-list-predefined-cta-btn"
                                :href="
                                    kadraGlobal.Url +
                                        '/single-my-lists?id=' +
                                        wish.ID
                                "
                                >View List</a
                            >
                        </div>
                    </perfect-scrollbar>
                    <div
                        :class="{
                            'product-info-box__add-list-cta-wrapper js-product-info-box__add-list-cta-wrapper product-info-box__add-list-cta-wrapper--active': newList,
                            'product-info-box__add-list-cta-wrapper js-product-info-box__add-list-cta-wrapper': !newList
                        }"
                    >
                        <a
                            class="product-info-box__add-list-cta js-product-info-box__add-list-cta"
                            href="javascript:;"
                            @click="newList = !newList"
                            >add new list</a
                        >
                        <div class="product-info-box__add-list-edit-name">
                            <input
                                type="text"
                                placeholder="List Name"
                                ref="inputTitle"
                            />
                            <a
                                class="product-info-box__add-list-btn js-product-info-box__add-list-btn"
                                href="javascript:;"
                                @click="createWishlist()"
                                >Save</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import SvgIcon from '../../base/SvgIcon/SvgIcon.vue';

export default {
    mixins: [onClickOutside],
    computed: mapState({
        list: state => state.List.list,
        wishlist: state => state.List.wishlist
    }),
    data() {
        return {
            kadraGlobal: kadraGlobal,
            productId: productId,
            productWishlist: {},
            show: false,
            favorites: {},
            newList: false
        };
    },
    beforeMount() {
        this.$store.dispatch('getList');
    },
    mounted() {
        document.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                this.closePopup();
            }
        });
        const specifiedElement = document.getElementsByClassName(
            'product-info-box__add-list-predefined-wrap'
        );
        const a = document.getElementsByClassName(
            'single-product__info-box-cta'
        );
        document.addEventListener('click', event => {
            if (specifiedElement.length !== 0) {
                const isClickInside = specifiedElement[0].contains(
                    event.target
                );
                let flag = false;
                a.forEach(element => {
                    if (element.contains(event.target)) {
                        flag = true;
                    }
                });
                if (!isClickInside && !flag) {
                    this.show = false;
                }
            }
        });
    },
    updated() {
        const popup = document.querySelector(
            '.product-info-box__add-list-predefined-wrap'
        );
        if (popup !== null) {
            const container = document.querySelector(
                '.single-product__wrapper'
            );
            const position = container.offsetTop - window.scrollY;
            const popupHeight = popup.offsetHeight;
            if (position < popupHeight) {
                popup.classList.add(
                    'product-info-box__add-list-predefined-wrap-bottom'
                );
            } else {
                popup.classList.remove(
                    'product-info-box__add-list-predefined-wrap-bottom'
                );
            }
        }
    },
    watch: {
        wishlist() {
            const obj = {};
            if (this.wishlist.length !== 0) {
                this.wishlist.forEach(wish => {
                    obj[wish.ID] = [];
                    this.list.forEach(item => {
                        if (item.status === wish.ID) {
                            obj[wish.ID].push(item.product_id);
                        }
                    });
                });
                this.productWishlist = obj;
            }
            this.setFavorites();
        }
    },
    components: {
        PerfectScrollbar,
        SvgIcon
    },
    methods: {
        closePopup() {
            this.show = false;
        },
        addToFavorites(event) {
            const _self = event.currentTarget;
            _self.parentElement.classList.add('loading');
            setTimeout(() => {
                _self.parentElement.classList.remove('loading');
            }, 1000);
            event.target.checked
                ? this.$store.dispatch('addToFavorites', this.productId)
                : this.$store.dispatch('removeFromFavorites', this.productId);
        },
        addToWishlist(id, event) {
            const _self = event.currentTarget;
            _self.parentElement.classList.add('loading');
            setTimeout(() => {
                _self.parentElement.classList.remove('loading');
            }, 1000);
            const obj = {
                listId: id,
                product_id: this.productId
            };
            event.target.checked
                ? this.$store.dispatch('addToWishlist', obj)
                : this.$store.dispatch('removeFromWishlist', obj);
        },
        check(id) {
            const arr = this.productWishlist[id];
            const productId = this.productId;
            if (arr.length !== 0) {
                if (arr.includes(productId)) {
                    return true;
                }
            }
        },
        setFavorites() {
            const obj = {};
            this.list.forEach(item => {
                if (item.status === 'favorites') {
                    obj[item.product_id] = item;
                }
            });
            this.favorites = obj;
        },
        createWishlist() {
            const val = this.$refs.inputTitle.value;
            const obj = this.wishlist.find(
                x => x.title.toLowerCase() === val.toLowerCase()
            );
            if (obj) {
                this.$refs.inputTitle.classList.add('list-name-input-invalid');
                return;
            }

            if (val !== '') {
                this.$store.dispatch('createWishlist', {
                    id: this.productId,
                    title: val
                });
                this.$refs.inputTitle.value = '';
                this.newList = false;
            }
        },
        wishTitleShort(title) {
            if (title.length > 27) {
                return title.substring(0, 27) + '...';
            } else {
                return title;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.vue-block {
    margin-left: auto;
    position: relative;
}

.product-info-box__add-list-predefined-wrap {
    position: absolute;
    top: -15px;
    right: 0;
    transform: translateY(-100%);
    width: 289px;
    min-height: 182px;
    height: auto;
    padding: 19px 19px 10px;
    border-radius: 5px;
    box-shadow: 0 0 35px rgba($black, 0.1);
    background: $white;
    z-index: 2;

    &::after {
        position: absolute;
        right: 35px;
        bottom: -12px;
        content: '';
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-top: 12px solid $white;
    }

    &:hover {
        z-index: 3;
    }

    @include mq(768px) {
        width: 250px;
    }

    .list-name-input-invalid {
        border: 1px solid $red;
    }
}
</style>
